<template>
  <div
    class="progress-circle prgrsscircle"
    :style="`--stroke-width: ${strokeWidthPx}px; --value:${valueUnit}`"
  >
    <!-- {{ valueUnit }} -->
    <!-- <slot></slot> -->
    <svg>
      <circle
        class="prgrsscircle_back"
        cx="50%"
        cy="50%"
        :r="`calc(50% - ${strokeWidthPx / 2}px)`"
        fill="none"
        pathLength="100"
      />
      <circle
        class="prgrsscircle_percent"
        cx="50%"
        cy="50%"
        :r="`calc(50% - ${strokeWidthPx / 2}px)`"
        fill="none"
        pathLength="100"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'ProgressCircle',
  props: {
    valueUnit: { default: () => 33 },
    strokeWidthPx: { default: () => 4 },
  },
}
</script>
<style lang="scss" scoped>
.prgrsscircle {
  --value: 25;
  --stroke-width: 4px;
  --clr-stroke: var(--clr-primary);
  --clr-stroke-back: var(--clr-black-2);
  --size: 2rem;
  --transition: 1s;
  // --anim-time: 14s;
  height: var(--size);
  width: var(--size);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  &:after {
    content: '';
    position: absolute;
    height: 100%;
    width: 100%;
    border-radius: 50%;
    border: var(--stroke-width) solid var(--clr-circle-back);
  }
  svg {
    width: 100%;
    height: 100%;
    position: absolute;
    transform: rotate(-90deg);
  }
  &_percent {
    stroke-dasharray: 100;
    stroke-dashoffset: calc(100 - var(--value));
    stroke-width: var(--stroke-width);
    stroke: var(--clr-stroke);
    stroke-linecap: round;
    transition: var(--transition);
  }
  &_back {
    stroke-dasharray: 100;
    stroke-dashoffset: 0;
    stroke-width: var(--stroke-width);
    stroke: var(--clr-stroke-back);
    stroke-linecap: round;
  }

  // &_timebank {
  //   animation: Timebank var(--anim-time) linear infinite;
  //   // animation: Timebank var(--anim-time) linear;
  //   @keyframes Timebank {
  //     0% {
  //       --value: 0;
  //       --clr-stroke: var(--clr-primary);
  //     }
  //     49% {
  //       --clr-stroke: var(--clr-primary);
  //     }
  //     50% {
  //       --clr-stroke: var(--clr-yellow);
  //     }
  //     74% {
  //       --clr-stroke: var(--clr-yellow);
  //     }
  //     75% {
  //       --clr-stroke: red;
  //       --value: 100;
  //     }
  //     100% {
  //       --clr-stroke: red;
  //       --value: 100;
  //     }
  //   }
  // }
}
</style>
